module.exports = __webpack_public_path__ + "static/media/Thoracic-Surgery-post-op-1@3x.1888895f.png";